import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
// import {
//     clearImportExcelPlanData,
//     downloadExcel2,
//     importExcelData,
//     setDataNull2,
// } from "../../store/order/slice";
import {
    downloadSampleFileRequest,
    clearDataExcel,
    uploadPlanExcelRequest,
    getSampleExcel,
    importExcel,
} from "../../store/Excels/slice";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import UploadFile from "../../components/UploadFile";
import { useFormik } from "formik";
import { Toast } from "primereact/toast";
import { site } from "../../api/url_helper";
import "../../assets/scss/theme-base/index.css";
import { ProgressSpinner } from "primereact/progressspinner";
import { FILE_TYPES } from "../../constants/fileTypes";
import axios from "axios";
import { getDataAll } from "../../store/processings/slice";

const ModalImportExcel = ({ visible, onHide, id, type }) => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const toast = useRef(null);
    const [successCount, setSuccessCount] = useState(null);
    const [errorCount, setErrorCount] = useState(null);
    const [errorFileUrl, setErrorFileUrl] = useState(null);
    const [uploadResult, setUploadResult] = useState(null);

    const [isResultDialogVisible, setIsResultDialogVisible] = useState(false);

    const {
        // uploadResult,
        errorUpload,
        planSampleExcel,
        errorPlanSampleExcel,
        sampleExcel,
        errorExcel,
    } = useSelector(
        (state) => ({
            // uploadResult: state.Production.importData,
            errorUpload: state.Production.errorImportData,
            planSampleExcel: state.Production.excelData2,
            errorPlanSampleExcel: state.Production.errorExcelData2,
            sampleExcel: state.Excel.sampleExcel.data,
            errorExcel: state.Excel.sampleExcel.error,
        }),
        shallowEqual
    );

    const handleDownloadClick = () => {
        setLoading(true);
        dispatch(getSampleExcel(type));
    };

    const showToast = (severity, summary, detail) => {
        toast.current?.show({ severity, summary, detail, life: 3000 });
    };

    useEffect(() => {
        if (sampleExcel) {
            setLoading(false);

            const fileUrl = `${site}/${sampleExcel?.data?.url}`;

            const link = document.createElement("a");
            link.href = fileUrl;
            link.setAttribute("download", "Sample data.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            dispatch(clearDataExcel());
            showToast("success", "Thành công", "Tải thành công");
        } else if (errorExcel) {
            setLoading(false);
            showToast("error", "Thất bại", errorExcel.response.data.message);
            dispatch(clearDataExcel());
        }
    }, [sampleExcel, errorExcel, dispatch]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {},
        onSubmit: async () => {
            const formData = new FormData();
            if (selectedFiles.length > 0) {
                formData.append("file", selectedFiles[0]);
            } else {
                showToast(
                    "error",
                    "Thất bại",
                    "Vui lòng chọn một file để tải lên"
                );
                setLoading(false);
                return;
            }
            try {
                const response = await axios.post(
                    `${site}/api/excels/import?type=processing`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                setUploadResult(response.data.data);
                dispatch(
                    getDataAll({
                        page: 1,
                        limit: 10,
                    })
                );
                setLoading(false);
                if (response.data.data.file) {
                    setIsResultDialogVisible(true);
                    setSuccessCount(response.data.data?.successCount);
                    setErrorCount(response.data.data?.errorCount);
                    const file = uploadResult?.file;
                    const fileUrl = `${site}/${file}`;
                    setErrorFileUrl(fileUrl);
                } else {
                    showToast("success", "Thành công", "Nhập thành công");
                    onHide();
                }
                setUploadResult(null);
            } catch (error) {}
            // dispatch(
            //     importExcel({
            //         type,
            //         file: selectedFiles,
            //     })
            // );
        },
    });

    //   useEffect(() => {
    //     console.log("render");
    //     if (uploadResult?.file !== null && uploadResult) {
    //       setLoading(false);
    //       setIsResultDialogVisible(true);
    //       setSuccessCount(uploadResult?.successCount);
    //       setErrorCount(uploadResult?.errorCount);
    //       const file = uploadResult?.file;

    //       if (file) {
    //         const fileUrl = `${site}/${file}`;
    //         setErrorFileUrl(fileUrl);
    //       }
    //       //   formik.resetForm();
    //       //   dispatch(clearDataExcel());
    //     } else if (errorUpload) {
    //       setLoading(false);
    //       const file = errorUpload?.file;
    //       if (file) {
    //         const fileUrl = `${site}/${file}`;
    //         const link = document.createElement("a");
    //         link.href = fileUrl;
    //         link.setAttribute("download", "Error data.xlsx");
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //         // dispatch(clearDataExcel());
    //         // setUploadResult(null);
    //       }
    //       showToast("error", "Thất bại", errorUpload?.response?.data?.message);
    //     }
    //   }, [uploadResult, errorUpload]);

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={visible}
                onHide={onHide}
                className="responsive-dialog"
                header="Nhập từ Excel"
                style={{ width: "40%" }}
            >
                {loading ? (
                    <div className="flex justify-content-center align-items-center">
                        <ProgressSpinner />
                    </div>
                ) : (
                    <>
                        <p className="font-bold">Các bước</p>
                        <div className="bg-yellow-100 px-5 py-3 line-height-4 border-round-md my-4">
                            <span>
                                1. Tải file mẫu và nhập dữ liệu (
                                <span
                                    className="text-blue-500 font-bold underline cursor-pointer"
                                    onClick={handleDownloadClick}
                                >
                                    Tải file mẫu
                                </span>
                                )
                            </span>
                            <p>2. Nhập dữ liệu chính xác theo các trường.</p>
                            <p className="text-red-500">
                                Lưu ý: Không thay đổi tên và thứ tự các cột.
                            </p>
                        </div>
                        <UploadFile
                            onUpload={() => {}}
                            getFiles={setSelectedFiles}
                            clearFiles={false}
                            isMultiple={false}
                            fileTypes={FILE_TYPES.excel}
                        />
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "40px",
                                gap: "1rem",
                            }}
                        >
                            <Button
                                label="Hủy"
                                className="px-5 py-2 bg-white border-none text-400"
                                severity="secondary"
                                onClick={onHide}
                            />
                            <Button
                                label="Nhập"
                                className="px-5 py-2 bg-green-700"
                                disabled={selectedFiles.length === 0}
                                onClick={formik.handleSubmit}
                                type="submit"
                            />
                        </div>
                    </>
                )}
            </Dialog>
            <Dialog
                visible={isResultDialogVisible}
                onHide={() => {
                    setIsResultDialogVisible(false);
                }}
                className="responsive-dialog"
                header="Kết quả nhập dữ liệu"
                style={{ width: "40%" }}
            >
                <div className="surface-100 border-round-md p-3 line-height-4">
                    <div className="font-bold text-green-700">
                        Thành công: {successCount}
                    </div>
                    <span className="text-red-500 font-bold">
                        Thất bại: {errorCount}
                        <a
                            href={errorFileUrl}
                            className="text-blue-500 underline cursor-pointer ml-2"
                            download="Error data.xlsx"
                        >
                            Tải file
                        </a>
                    </span>
                </div>
            </Dialog>
        </>
    );
};

export default ModalImportExcel;
